import { GQLContentPageFragment } from '@theprintbar/graphql';
import { ImageSize } from '@theprintbar/shared';
import { PromoImageContainer } from '@theprintbar/ui';

interface AuthContainerProps {
	content: GQLContentPageFragment;
	children: React.ReactNode;
	title?: string;
	subtitle?: string;
}

export function AuthContainer({ content, children, title, subtitle }: AuthContainerProps) {
	const hero = content.heroBanner.structure?.[0];
	if (!hero) return null;

	return (
		<div className="grid grid-cols-1 lg:grid-cols-2">
			<h1 className="hidden">{content.headingTag || content.metaTitle}</h1>
			<PromoImageContainer className="h-48 lg:h-auto" size={ImageSize.HD} promoImage={hero.image} />
			<div className="py-10 lg:py-20 px-4 lg:px-16 xl:px-36 2xl:px-56 min-h-[60vh]">
				<h2 className="mb-5 font-display font-light text-2xl lg:text-3xl capitalize">{title || hero.title}</h2>
				{subtitle && <p className="mb-5 font-display">{subtitle}</p>}
				{children}
			</div>
		</div>
	);
}
